module.exports = __webpack_public_path__ + "img/guide04.ff760a34.jpg";